import React from "react"
import { Avatar, Button } from "@mui/material"
import i18n from "@/i18n"
import { type GetCurrentUserWithInfoQuery } from "@/graphql/graphql"

type CurrentUser = NonNullable<GetCurrentUserWithInfoQuery["currentUser"]>

const STYLES = {
  container: "flex items-center gap-6 mb-6",
  infoWrapper: "flex flex-col justify-center gap-2",
  buttonsRow: "flex gap-2",
  helpText: "text-sm text-gray-500 m-0",
} as const

export type AvatarSectionProps = {
  currentUser: CurrentUser
  avatarPreview: string | null
  avatarFile: File | null
  handleAvatarChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  handleRemoveAvatar: () => Promise<void>
}

const AvatarSection: React.FC<AvatarSectionProps> = ({
  currentUser,
  avatarPreview,
  avatarFile,
  handleAvatarChange,
  handleRemoveAvatar,
}) => (
  <div className={STYLES.container}>
    <Avatar
      data-testid="settings-profile-avatar"
      src={avatarPreview || currentUser.avatarUrl || undefined}
      sx={{ width: 80, height: 80 }}
    >
      {currentUser.firstName?.[0]}
      {currentUser.lastName?.[0]}
    </Avatar>
    <div className={STYLES.infoWrapper}>
      <input
        accept="image/*"
        style={{ display: "none" }}
        id="avatar-upload"
        type="file"
        data-testid="settings-profile-avatar-input"
        onChange={handleAvatarChange}
      />
      <div className={STYLES.buttonsRow}>
        <label htmlFor="avatar-upload">
          <Button variant="outlined" size="small" component="span" data-testid="settings-profile-btn-change-avatar">
            {i18n.t("app.settings.profile.overview.change_avatar")}
          </Button>
        </label>
        <Button
          variant="outlined"
          size="small"
          color="error"
          onClick={handleRemoveAvatar}
          disabled={!currentUser.avatar && !avatarFile}
          data-testid="settings-profile-btn-remove-avatar"
        >
          {i18n.t("app.settings.profile.overview.remove_avatar")}
        </Button>
      </div>
      <p className={STYLES.helpText}>{i18n.t("app.settings.profile.overview.avatar_help")}</p>
    </div>
  </div>
)

export default AvatarSection
